import React, { useContext } from "react";
import { ProcessContext } from "../../../../contexts/ProcessContext";
import {
  ALLOWED_PRODUCTS_FOR_CARD,
  ALLOWED_PRODUCTS_FOR_CREDIT_LINE,
  ALLOWED_PRODUCTS_FOR_LOAN,
} from "./config";
import { CreditLineSummary } from "./CreditLineSummary/CreditLineSummary";
import { LoanSummary } from "./LoanSummary/LoanSummary";
import { useSummaryAndAdjust } from "./shared/hooks/useSummaryAndAdjust";
import { CardSummary } from "./CardSummary/CardSummary";
import { BorrowerSelectionLoanSummary } from "./BorrowerSelectionLoanSummary/BorrowerSelectionLoanSummary";

export default function SummaryAndAdjust(props) {
  const {
    state: { loan, checkoutSession },
  } = useContext(ProcessContext);

  useSummaryAndAdjust();

  const productType = loan?.loan_conditions?.product;

  const currentPaymentMethodType = checkoutSession?.payment_intents?.find(
    (paymentIntent) => paymentIntent.payment_method_id === loan.id
  )?.payment_method_type;

  const processingStrategyOrderBy = checkoutSession?.payment_methods?.find(
    (paymentMethod) => paymentMethod.type === currentPaymentMethodType
  )?.options.processing_strategy.details.order_by;

  if (processingStrategyOrderBy === "borrower_selection") {
    return <BorrowerSelectionLoanSummary {...props} />;
  }

  return (
    <>
      {ALLOWED_PRODUCTS_FOR_CREDIT_LINE.includes(productType) && (
        <CreditLineSummary {...props} />
      )}
      {ALLOWED_PRODUCTS_FOR_LOAN.includes(productType) && (
        <LoanSummary {...props} />
      )}
      {ALLOWED_PRODUCTS_FOR_CARD.includes(productType) && (
        <CardSummary {...props} />
      )}
    </>
  );
}
